// extracted by css-extract-rspack-plugin
export default {"Box":"Panel-module__Box__AdYCI"};